import React from 'react';
import { colorType, withTheme } from 'common/styling/theme';

export const PartnershipIconActive = ({ gradientStartColor, gradientEndColor }) => (
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 19">
      <defs>
        <linearGradient id="linearGradient-4" x1="4.248%" x2="95.826%" y1="86.836%" y2="18.008%">
          <stop stopColor={gradientStartColor.hex} offset="0%" />
          <stop stopColor={gradientEndColor.hex} offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M5.46889 10.859L11.54 14.441M11.5311 4.559L5.46889 8.141M16.5 3.2C16.5 4.69117 15.3061 5.9 13.8333 5.9C12.3606 5.9 11.1667 4.69117 11.1667 3.2C11.1667 1.70883 12.3606 0.5 13.8333 0.5C15.3061 0.5 16.5 1.70883 16.5 3.2ZM5.83333 9.5C5.83333 10.9912 4.63943 12.2 3.16667 12.2C1.69391 12.2 0.5 10.9912 0.5 9.5C0.5 8.00883 1.69391 6.8 3.16667 6.8C4.63943 6.8 5.83333 8.00883 5.83333 9.5ZM16.5 15.8C16.5 17.2912 15.3061 18.5 13.8333 18.5C12.3606 18.5 11.1667 17.2912 11.1667 15.8C11.1667 14.3088 12.3606 13.1 13.8333 13.1C15.3061 13.1 16.5 14.3088 16.5 15.8Z"
        stroke="url(#linearGradient-4)"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
);

PartnershipIconActive.propTypes = {
  gradientStartColor: colorType,
  gradientEndColor: colorType,
};

PartnershipIconActive.defaultProps = {
  gradientStartColor: {},
  gradientEndColor: {},
};

const ThemedPartnershipIconActive = withTheme(({ colors: { gradientStart, gradientEnd } }) => ({
  gradientStartColor: gradientStart,
  gradientEndColor: gradientEnd,
}))(PartnershipIconActive);

export default ThemedPartnershipIconActive;
